import { Input, Button, Tooltip, Table, DatePicker, Popconfirm } from "antd";
import locale from 'antd/es/date-picker/locale/zh_CN';
import React from "react";
import { SearchOutlined, PlusSquareOutlined } from '@ant-design/icons';
import CreateChannel from './com/createChannel'
import './index.sass'
import api from "../../utils/api";

const { RangePicker } = DatePicker;

export default class Channel extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            change_fans_flag: 0,
            createChannelShow: false,
            dataSource: []
        }
    }

    componentDidMount() {
        this.getChannels()
    }

    change_fans_type = (flag) => {
        //console.log(flag)
        this.setState({
            change_fans_flag: flag
        })
    }

    getChannels = async () => {//获取渠道
        let res = await api('get-channels');
        if (res.code === 200) {
            this.setState({
                dataSource: res.data
            })
        }
        console.log(res)
    }


    render() {

        const columns = [
            {
                title: '渠道名称',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '操作',
                render: (ctx) => {
                    return (
                        <div className='flex'>

                            <p onClick={() => { this.editorChannel(ctx) }} className='pointer mgr10'>编辑</p>

                            <Popconfirm
                                title='确认删除？'
                                okText='确认'
                                cancelText='取消'
                                onConfirm={() => {

                                    this.delChannel(ctx)

                                }}
                            >
                                <p className='warn pointer'>删除</p>
                            </Popconfirm>


                        </div>
                    )
                }
            },
        ];


        let { change_fans_flag, createChannelShow, dataSource } = this.state

        return (
            <div className='channel'>
                <div className='userList'>

                    {/* 头部 */}
                    <div className='userInfo'>

                        <p>首页/</p>
                        <div className='flex user_data'>
                            <div className='user_left flex'>

                                <div className='user_avatar'></div>
                                <div className='words'>
                                    <p className='welcome'>用户名</p>
                                    <div className='flex wish'>
                                        <label>当前身份 | </label>
                                        <p> 自己</p>
                                    </div>
                                </div>


                            </div>
                            <div className='user_right'>

                                <ul className='flex census'>
                                    <li>
                                        <label>全部渠道</label>
                                        <p>26</p>
                                    </li>
                                </ul>

                            </div>
                        </div>

                    </div>

                    <div className='record'>
                        {/* <div className='change_fans'>
                            <ul className='flex tabs'>
                                <li className={change_fans_flag === 0 ? 'active' : ''} onClick={() => { this.change_fans_type(0) }}>我的粉丝</li>
                                <li className={change_fans_flag === 1 ? 'active' : ''} onClick={() => { this.change_fans_type(1) }}>我的商户</li>
                                <li className={change_fans_flag === 2 ? 'active' : ''} onClick={() => { this.change_fans_type(2) }}>我屏蔽的</li>
                            </ul>
                        </div> */}


                        <div className='change_fans flex search'>
                            <div className='flex'>
                                <div className='flex line alignCenter'>
                                    搜索昵称：
                                    <Input placeholder='搜索昵称：' />
                                </div>

                                {/* <div className='flex line alignCenter'>
                                日期：
                                <RangePicker locale={locale} />
                            </div> */}


                                <div>
                                    <Button icon={<SearchOutlined />}>搜索</Button>

                                    <Button>重置</Button>
                                </div>

                            </div>

                            <Button onClick={() => { this.setState({ createChannelShow: true }) }} icon={<PlusSquareOutlined />} className='createChannelBtn'>新建渠道</Button>



                        </div>


                        <div className='change_fans'>
                            <Table dataSource={dataSource} columns={columns} />
                        </div>


                    </div>
                </div>

                {
                    createChannelShow ? <CreateChannel update={(e) => { this.getChannels() }} colsePop={(e) => { this.setState({ createChannelShow: !e }) }} /> : null
                }


            </div>
        )
    }


}